import type { ReactNode } from "react";
import { BrowserRouter } from "react-router";

interface AppBrowserRouterProps {
  children: ReactNode;
}

export const AppBrowserRouter = ({ children }: AppBrowserRouterProps) => (
  <BrowserRouter useTransitions={false}>{children}</BrowserRouter>
);
